import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtmTextH5Component } from './atm-text-h5.component';

@NgModule({
  declarations: [AtmTextH5Component],
  imports: [CommonModule],
  exports: [AtmTextH5Component],
})
export class AtmTextH5Module {}
